import { render } from "./ExtraInfo.vue?vue&type=template&id=e554c4dc&scoped=true"
import script from "./ExtraInfo.vue?vue&type=script&lang=js"
export * from "./ExtraInfo.vue?vue&type=script&lang=js"

import "./ExtraInfo.vue?vue&type=style&index=0&id=e554c4dc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e554c4dc"]])

export default __exports__